// import $ from "jquery";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import API_BASE_URL from "../../../helper.js";

// // Function to show success modal
// function showSuccessModal(message) {
//     $("#successMessage").text(message);
//     const modal = new window.bootstrap.Modal(document.getElementById("successModal"));
//     modal.show();
// }

// window.loadAdmins = function () {
//     loadAllAdmins();
// };

// $(document).ready(function () {

//     // ADD Admin
//     $("#addAdminForm").submit(function (e) {
//         e.preventDefault();

//         const formData = new FormData();
//         formData.append("email", $("#email").val());
//         formData.append("password", $("#password").val());

//         $.ajax({
//             url: `${API_BASE_URL}/api/admin/add`,
//             type: "POST",
//             data: formData,
//             contentType: false,
//             processData: false,
//             success: function () {
//                 showSuccessModal("Admin Added Successfully!");
//                 $("#addAdminForm")[0].reset();

//                 const modal = window.bootstrap.Modal.getInstance(document.getElementById("adminModal"));
//                 modal.hide();
//                 loadAllAdmins();
//             },
//             error: function (err) {
//                 console.error(err);
//                 alert("Failed to add Admin!");
//             }
//         });
//     });

//     // LOAD ALL Admin DATA
//     function loadAllAdmins() {
//         $.ajax({
//             url: `${API_BASE_URL}/api/admin/all`,
//             type: "GET",
//             success: function (admins) {
//                 let rows = "";
//                 admins.reverse().forEach((a, i) => {
//                     rows += `
//                         <tr>
//                             <td>${i + 1}</td>
//                             <td>${a.email}</td>
//                             <td>${a.password}</td>
//                             <td>
//                                 <button class="btn btn-primary btn-sm editAdminBtn" data-id="${a.id}">Edit</button>
//                                 <button class="btn btn-danger btn-sm deleteAdmin" data-id="${a.id}">Delete</button>
//                             </td>
//                         </tr>
//                     `;
//                 });

//                 $("#allAdminData").html(rows);
//             },
//             error: function (err) {
//                 console.error(err);
//             }
//         });
//     }

//     // OPEN EDIT MODAL
//     $(document).on("click", ".editAdminBtn", function () {
//         const id = $(this).data("id");

//         $.ajax({
//             url: `${API_BASE_URL}/api/admin/get/${id}`,
//             type: "GET",
//             success: function (a) {

//                 $("#editId").val(a.id);
//                 $("#editEmail").val(a.email);
//                 $("#editPassword").val(a.password);

//                 new window.bootstrap.Modal(document.getElementById("editAdminModal")).show();
//             },
//             error: () => alert("Failed to fetch Admin data")
//         });
//     });

//     // UPDATE Admin
//     $("#editAdminForm").submit(function (e) {
//         e.preventDefault();

//         const id = $("#editId").val();
//         const formData = new FormData();

//         formData.append("email", $("#editEmail").val());
//         formData.append("password", $("#editPassword").val());

//         $.ajax({
//             url: `${API_BASE_URL}/api/admin/update/${id}`,
//             type: "POST",
//             contentType: false,
//             processData: false,
//             data: formData,
//             success: function () {
//                 showSuccessModal("Admin Updated Successfully!");
//                 loadAllAdmins();
//                 window.bootstrap.Modal.getInstance(document.getElementById("editAdminModal")).hide();
//             },
//             error: () => alert("Failed to update Admin")
//         });
//     });

//     // DELETE Admin
//     $(document).on("click", ".deleteAdmin", function () {
//         let id = $(this).data("id");

//         if (!window.confirm("Are you sure want to delete this Admin?")) return;

//         $.ajax({
//             url: `${API_BASE_URL}/api/admin/delete/${id}`,
//             type: "DELETE",
//             success: function () {
//                 showSuccessModal("Admin Deleted Successfully!");
//                 loadAllAdmins();
//             },
//             error: function (err) {
//                 console.error(err);
//                 alert("Failed to delete Admin!");
//             }
//         });
//     });

// });

import $ from "jquery";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import API_BASE_URL from "../../../helper.js";

// Function to show success modal
function showSuccessModal(message) {
    $("#successMessage").text(message);
    const modal = new window.bootstrap.Modal(document.getElementById("successModal"));
    modal.show();
}

// ✅ MOVE FUNCTION OUTSIDE (IMPORTANT)
function loadAllAdmins() {
    $.ajax({
        url: `${API_BASE_URL}/api/admin/all`,
        type: "GET",
        success: function (admins) {
            let rows = "";
            admins.reverse().forEach((a, i) => {
                rows += `
                    <tr>
                        <td>${i + 1}</td>
                        <td>${a.email}</td>
                        <td>${a.password}</td>
                        <td>
                            <button class="btn btn-primary btn-sm editAdminBtn" data-id="${a.id}">Edit</button>
                            <button class="btn btn-danger btn-sm deleteAdmin" data-id="${a.id}">Delete</button>
                        </td>
                    </tr>
                `;
            });

            $("#allAdminData").html(rows);
        },
        error: function (err) {
            console.error(err);
        }
    });
}

// ✅ EXPOSE TO REACT
window.loadAdmins = function () {
    loadAllAdmins();
};

$(document).ready(function () {

    // ADD Admin
    $("#addAdminForm").submit(function (e) {
        e.preventDefault();

        const formData = new FormData();
        formData.append("email", $("#email").val());
        formData.append("password", $("#password").val());

        $.ajax({
            url: `${API_BASE_URL}/api/admin/add`,
            type: "POST",
            data: formData,
            contentType: false,
            processData: false,
            success: function () {
                showSuccessModal("Admin Added Successfully!");
                $("#addAdminForm")[0].reset();

                const modal = window.bootstrap.Modal.getInstance(document.getElementById("adminModal"));
                modal.hide();
                loadAllAdmins();
            },
            error: function (err) {
                console.error(err);
                alert("Failed to add Admin!");
            }
        });
    });

    // OPEN EDIT MODAL
    $(document).on("click", ".editAdminBtn", function () {
        const id = $(this).data("id");

        $.ajax({
            url: `${API_BASE_URL}/api/admin/get/${id}`,
            type: "GET",
            success: function (a) {

                $("#editId").val(a.id);
                $("#editEmail").val(a.email);
                $("#editPassword").val(a.password);

                new window.bootstrap.Modal(document.getElementById("editAdminModal")).show();
            },
            error: () => alert("Failed to fetch Admin data")
        });
    });

    // UPDATE Admin
    $("#editAdminForm").submit(function (e) {
        e.preventDefault();

        const id = $("#editId").val();
        const formData = new FormData();

        formData.append("email", $("#editEmail").val());
        formData.append("password", $("#editPassword").val());

        $.ajax({
            url: `${API_BASE_URL}/api/admin/update/${id}`,
            type: "POST",
            contentType: false,
            processData: false,
            data: formData,
            success: function () {
                showSuccessModal("Admin Updated Successfully!");
                loadAllAdmins();
                window.bootstrap.Modal.getInstance(document.getElementById("editAdminModal")).hide();
            },
            error: () => alert("Failed to update Admin")
        });
    });

    // DELETE Admin
    $(document).on("click", ".deleteAdmin", function () {
        let id = $(this).data("id");

        if (!window.confirm("Are you sure want to delete this Admin?")) return;

        $.ajax({
            url: `${API_BASE_URL}/api/admin/delete/${id}`,
            type: "DELETE",
            success: function () {
                showSuccessModal("Admin Deleted Successfully!");
                loadAllAdmins();
            },
            error: function (err) {
                console.error(err);
                alert("Failed to delete Admin!");
            }
        });
    });

});